var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c("div", { staticClass: "modal-mask", on: { click: _vm.hide } }, [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-slideout modal-lg",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("div", { staticClass: "modal-content p-2" }, [
                _c("div", { staticClass: "modal-header px-4 pt-2 pb-0" }, [
                  _c("div", { staticStyle: { width: "100%" } }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase text-muted pt-1",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("img", {
                          staticClass: "back_icon mr-2",
                          attrs: {
                            src: require("@/assets/manager/back_button_icon.png")
                          }
                        }),
                        _vm._v("Back")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close float-right",
                        attrs: { type: "button" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "modal_reps_to_review d-none-" }, [
                    _c("div", { staticClass: "row mb-2 mt-3" }, [
                      _c("div", { staticClass: "col-8 pl-4" }, [
                        _c(
                          "div",
                          { staticClass: "h3 d-inline mr-2 text-uppercase" },
                          [_vm._v(_vm._s(_vm.assessment_title))]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "loading_show"
                      },
                      [_c("div", { staticClass: "spinner-border text-danger" })]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "preview-section" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 p-0 text-align-center" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "landing-page-content",
                              staticStyle: {
                                "padding-left": "5px",
                                "padding-right": "5px",
                                "text-align": "left"
                              }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.landingPageContent)
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-12 padding-lr-5  text-align-center",
                          staticStyle: { "padding-right": "0" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-info btn-md font-weight-bold rounded-pill px-5",
                              on: {
                                click: function($event) {
                                  return _vm.openAssessmentQuestionPage()
                                }
                              }
                            },
                            [_vm._v("Begin Assessment")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "25px" }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" })
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a89141ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a89141ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mentee/mentee_assessment_landing_new.vue
// module id = null
// module chunks = 